import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type NavigationService from "parog-web/services/navigation";

interface Signature {
  Args: { Positional: string[] };
  Return: string | undefined;
}

export default class ContextualRouteHelper extends Helper<Signature> {
  @service declare navigation: NavigationService;

  compute([
    contextualRoute
  ]: Signature["Args"]["Positional"]): Signature["Return"] {
    return this.navigation.getAbsoluteRouteFromContextual(contextualRoute);
  }
}
